<template>
  <div class="checkout">
    <NoPlanSelected v-if="hasNoPlanOrFrequency" />
    <span v-else>
      <CheckoutPaymentHeader
        @setPaymentType="setPaymentType"
        @setPlanAmount="setPlanAmount"
        :paymentType="paymentType"
        :frequency="frequency"
        :plans="plans"
        :plan="plan"
      />
      <CheckoutPaymentType v-if="!paymentType && planAmount" @setPaymentType="setPaymentType" />
      <CheckoutPaymentCreditCard v-if="isCreditCardPayment" :planAmount="planAmount" :frequency="frequency" />
      <CheckoutPaymentPix v-if="isPixPayment" :planAmount="planAmount" />
    </span>
  </div>
</template>

<script>
import CheckoutPaymentCreditCard from './checkout/components/CheckoutPaymentCreditCard.vue'
import CheckoutPaymentHeader from './checkout/components/CheckoutPaymentHeader.vue'
import CheckoutPaymentType from './checkout/components/CheckoutPaymentType.vue'
import CheckoutPaymentPix from './checkout/components/CheckoutPaymentPix.vue'
import NoPlanSelected from './checkout/fragments/NoPlanSelected.vue'

export default {
  name: 'Checkout',

  components: {
    CheckoutPaymentCreditCard,
    CheckoutPaymentHeader,
    CheckoutPaymentType,
    CheckoutPaymentPix,
    NoPlanSelected,
  },

  methods: {
    setPaymentType(type) {
      this.paymentType = type
    },

    setPlanAmount(value) {
      this.planAmount = value
    },
  },

  computed: {
    isPixPayment() {
      return this.paymentType === 'ASAAS_PIX'
    },

    isCreditCardPayment() {
      return this.paymentType === 'ASAAS_CREDIT_CARD'
    },

    hasNoPlanOrFrequency() {
      return !this.plan || !this.frequency
    },

    plans() {
      return {
        gold: {
          mensal: 399.5,
          trimestral: 349.5,
          anual: 299.5
        },
        black: {
          mensal: 599.5,
          trimestral: 549.5,
          anual: 499.5
        },
      }
    },
  },

  data() {
    return {
      paymentType: null,
      frequency: null,
      plan: null,
      planAmount: null,
    }
  },

  mounted() {
    this.frequency = this.$route.query.frequency
    this.plan = this.$route.query.plan
  },
}
</script>

<style lang="scss" scoped>
.checkout {
  max-width: 620px;
  margin: 0 auto;
  padding: 15px;
}
</style>
